import { render, staticRenderFns } from "./SpeechInput.vue?vue&type=template&id=1fdcb97f&scoped=true&"
import script from "./SpeechInput.vue?vue&type=script&lang=js&"
export * from "./SpeechInput.vue?vue&type=script&lang=js&"
import style0 from "./SpeechInput.vue?vue&type=style&index=0&id=1fdcb97f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdcb97f",
  null
  
)

export default component.exports